import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import s from './styles.module.scss';

export const EmptyPodFilterState: FC = () => {
  const { t } = useTranslation();

  return (
    <div data-cy="empty-pod-filter-state" role="status" aria-live="polite">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div className={s['empty-description']}>
            <div>
              {t(
                'messages.noMatchingPatients',
                'No matching patients in this section',
              )}
            </div>
            <div className={s['empty-hint']}>
              {t(
                'messages.tryChangingFilter',
                'Try changing the Pod filter or other applied filters.',
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default EmptyPodFilterState;
